module.exports = __webpack_public_path__ + "static/img/houzz.e9a7eb1c.jpg";